/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Dok_OkInputs */

const en_tut_dok_ok = /** @type {(inputs: Tut_Dok_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The indicator above the editor reads **Semua perubahan tersimpan**, and **Unduh** produces a file in the format you picked.`)
};

const id_tut_dok_ok = /** @type {(inputs: Tut_Dok_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indikator di atas editor berbunyi **Semua perubahan tersimpan**, dan **Unduh** menghasilkan berkas dalam format yang Anda pilih.`)
};

/**
* | output |
* | --- |
* | "The indicator above the editor reads **Semua perubahan tersimpan**, and **Unduh** produces a file in the format you picked." |
*
* @param {Tut_Dok_OkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_dok_ok = /** @type {((inputs?: Tut_Dok_OkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Dok_OkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_dok_ok(inputs)
	return en_tut_dok_ok(inputs)
});